import { Loadable } from '../../components/common/loadable/loadable';

export const ProjectOverviewLazyLoadContainer = Loadable<any>({
  loader: () =>
    import(
      /* webpackChunkName: "project-overview" */ './project-overview.container'
    ).then((module) => module.ProjectOverviewContainer),
});
